module.exports = __webpack_public_path__ + "img/cloth_g1_hat_10.dd1787b2.svg";